import { create } from 'zustand';
import {
  createJSONStorage,
  persist,
  subscribeWithSelector,
} from 'zustand/middleware';

interface ITrackingUserParams {
  stag?: string | null;
  utm_source?: string | null;
  utm_medium?: string | null;
  utm_campaign?: string | null;
  utm_content?: string | null;
  utm_term?: string | null;
  ref_code?: string | null;
  promo_id?: string | null;
  campaign_id?: string | null;
  app_id?: string;
  pwa_id?: string;
}

interface ITrackingUserParamsStore extends ITrackingUserParams {
  setTrackingUserParams: (params: ITrackingUserParams) => void;
}

export const useTrackingUserParamsStore = create<ITrackingUserParamsStore>()(
  subscribeWithSelector(
    persist(
      (set) => ({
        setTrackingUserParams: (params) => {
          set({ ...params });
        },
      }),
      {
        name: 'tracking-user-params',
        storage: createJSONStorage(() => localStorage),
        partialize: (state) => ({
          stag: state.stag,
          campaign_id: state.campaign_id,
          promo_id: state.promo_id,
          pwa_id: state.pwa_id,
          app_id: state.app_id,
        }),
      }
    )
  )
);
